// extracted by mini-css-extract-plugin
export default {"userStatsContainer":"UserStats_userStatsContainer__qTLHP"};